/* Lathrop Quick Smog — small, dependency-free enhancements.
   Everything here is progressive: the site works without it. */
(function () {
  'use strict';

  var TZ = 'America/Los_Angeles';

  /* ---------- analytics boundary (no personal data, ever) ----------
     Events go to Shopify's customer-events bus (Settings > Customer events),
     where a GA4 or other pixel can subscribe, and to window.dataLayer if present. */
  var sent = {};
  function track(name, props) {
    var data = Object.assign({ page: location.pathname }, props || {});
    try {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        Shopify.analytics.publish('lqs_' + name, data);
      }
    } catch (e) {}
    if (Array.isArray(window.dataLayer)) window.dataLayer.push(Object.assign({ event: 'lqs_' + name }, data));
  }
  function trackOnce(name, props, key) {
    var k = key || name;
    if (sent[k]) return;
    sent[k] = true;
    var store = null;
    try { store = window.sessionStorage; } catch (e) {}
    try { if (store && store.getItem('lqs_ev_' + k)) return; if (store) store.setItem('lqs_ev_' + k, '1'); } catch (e) {}
    track(name, props);
  }

  document.addEventListener('click', function (e) {
    var el = e.target.closest('[data-track], a[href^="tel:"], [data-coupon-link]');
    if (!el) return;
    var name = el.getAttribute('data-track');
    var src = el.getAttribute('data-track-source') || 'link';
    if (!name && el.matches('a[href^="tel:"]')) name = 'call_link_clicked';
    if (!name && el.hasAttribute('data-coupon-link')) name = 'coupon_link_clicked';
    if (!name) return;
    var props = { source: src };
    if (name === 'booking_cta_clicked') {
      var href = el.getAttribute('href') || '';
      var m = href.match(/service=(smog|registration|combo)/);
      if (el.closest('[data-service-selector]')) {
        var chk = el.closest('form').querySelector('input[name="service"]:checked');
        if (chk) props.journey = chk.value;
      } else if (m) props.journey = m[1];
    }
    track(name, props);
  });

  /* ---------- time helpers (shop is in America/Los_Angeles) ---------- */
  function laNow() {
    var parts = new Intl.DateTimeFormat('en-US', {
      timeZone: TZ, weekday: 'short', year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', hourCycle: 'h23'
    }).formatToParts(new Date());
    var o = {};
    parts.forEach(function (p) { o[p.type] = p.value; });
    return {
      day: o.weekday.toLowerCase().slice(0, 3),
      ymd: o.year + '-' + o.month + '-' + o.day,
      mins: parseInt(o.hour, 10) * 60 + parseInt(o.minute, 10)
    };
  }
  function toMins(t) { var p = t.trim().split(':'); return parseInt(p[0], 10) * 60 + parseInt(p[1] || '0', 10); }
  function fmt(m) {
    var h = Math.floor(m / 60), mm = m % 60, s = h >= 12 ? 'PM' : 'AM', h12 = h % 12 || 12;
    return h12 + (mm ? ':' + String(mm).padStart(2, '0') : '') + ' ' + s;
  }
  function parseDay(raw) {
    if (!raw || /closed/i.test(raw)) return [];
    return raw.split(',').map(function (s) {
      var e = s.split('-');
      return e.length === 2 ? [toMins(e[0]), toMins(e[1])] : null;
    }).filter(Boolean);
  }

  /* ---------- Open now / Closed (only rendered when all 7 days are configured) ---------- */
  /* Open right now by the hours in Theme settings: true, false, or null if hours aren't set. */
  var SHOP_OPEN = null, SHOP_OPENS = '';

  function initOpenStatus() {
    var DAYS = ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun'];
    var NAMES = { mon: 'Monday', tue: 'Tuesday', wed: 'Wednesday', thu: 'Thursday', fri: 'Friday', sat: 'Saturday', sun: 'Sunday' };
    var now = laNow();
    document.querySelectorAll('.hours tr[data-day="' + now.day + '"]').forEach(function (tr) { tr.classList.add('is-today'); });
    var src = document.getElementById('lqs-hours');
    var chips = document.querySelectorAll('[data-open-status]');
    if (!src) return;
    var hours;
    try { hours = JSON.parse(src.textContent); } catch (e) { return; }
    var today = parseDay(hours[now.day]);
    var text = '', open = false;
    for (var i = 0; i < today.length; i++) {
      if (now.mins >= today[i][0] && now.mins < today[i][1]) { open = true; text = 'Open now until ' + fmt(today[i][1]); break; }
    }
    if (!open) {
      var later = today.filter(function (s) { return s[0] > now.mins; })[0];
      if (later) text = 'Closed now. Opens at ' + fmt(later[0]);
      else {
        var idx = DAYS.indexOf(now.day);
        for (var d = 1; d <= 7; d++) {
          var key = DAYS[(idx + d) % 7], s = parseDay(hours[key]);
          if (s.length) { text = 'Closed now. Opens ' + (d === 1 ? 'tomorrow' : NAMES[key]) + ' at ' + fmt(s[0][0]); break; }
        }
      }
    }
    SHOP_OPEN = open;
    if (!open && text) SHOP_OPENS = text.replace(/^Closed now\. /, '');
    if (!text) return;
    chips.forEach(function (el) {
      el.querySelector('[data-open-status-text]').textContent = text;
      el.classList.add(open ? 'is-open' : 'is-closed');
      el.hidden = false;
    });
  }

  /* ---------- mobile menu ---------- */
  function initMenu() {
    var dlg = document.querySelector('[data-menu]');
    var btn = document.querySelector('[data-menu-open]');
    if (!dlg || !btn || typeof dlg.showModal !== 'function') return;
    btn.addEventListener('click', function () { dlg.showModal(); btn.setAttribute('aria-expanded', 'true'); });
    dlg.addEventListener('close', function () { btn.setAttribute('aria-expanded', 'false'); btn.focus(); });
    dlg.querySelectorAll('[data-menu-close], a').forEach(function (a) { a.addEventListener('click', function () { dlg.close(); }); });
    dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });
  }

  /* ---------- hero lightning trace: measure bolt tip -> service picker ---------- */
  function initTrace() {
    var hero = document.querySelector('.hero');
    if (!hero) return;
    var svg = hero.querySelector('.hero__trace');
    var sel = hero.querySelector('.hero__selector');
    if (!svg || !sel) return;
    function place() {
      if (window.matchMedia('(max-width: 749px)').matches) { hero.classList.remove('is-traced'); return; }
      var tip = svg.getBoundingClientRect();
      var box = sel.getBoundingClientRect();
      var drop = Math.round(box.top - tip.top);
      if (drop < 12) { hero.classList.remove('is-traced'); return; }
      hero.style.setProperty('--trace-drop', drop + 'px');
      sel.style.setProperty('--tip-x', Math.max(0, Math.round(tip.left + 2 - box.left)) + 'px');
      hero.classList.add('is-traced');
    }
    var img = hero.querySelector('.brand-logo__img');
    if (img && !img.complete) img.addEventListener('load', place, { once: true });
    place();
    if ('ResizeObserver' in window) new ResizeObserver(function () { window.requestAnimationFrame(place); }).observe(hero);
  }

  /* ---------- hero logo on scroll ----------
     Sets --lp on the hero from 0 (top of the page) to 1 (the logo has mostly scrolled by); the CSS
     turns that into the charge, the spark and the current. The smoke moves the whole time the logo
     is on screen (drift). One style write per frame, only when it
     changes. Nothing moves with reduced motion. */
  function initLogoScroll() {
    var hero = document.querySelector('.hero');
    var logo = hero && hero.querySelector('.hero__logo');
    if (!logo || !window.requestAnimationFrame) return;
    var still = window.matchMedia('(prefers-reduced-motion: reduce)');
    var span = 600, last = -1, queued = false;
    // The smoke: two layers of one seamless texture drift up (one a little right, one left and faster)
    // for every pixel scrolled, the whole time the logo is on screen. Moving a layer by one whole tile
    // looks the same, so they wrap around and never run out.
    var smoke = logo.querySelectorAll('.hero__smoke i');
    var FLOW = [[0.05, -0.34, 0.40, ''], [-0.09, -0.56, 0.48, ' rotate(90deg)']];
    var tiles = [];
    function wrap(v, t) { v %= t; return v > 0 ? v - t : v; }
    function measure() {
      var r = logo.getBoundingClientRect();
      span = Math.max(240, (r.bottom + window.pageYOffset) * 0.62);
      tiles = Array.prototype.map.call(smoke, function (el, i) {
        var t = Math.max(8, Math.round(el.offsetWidth * FLOW[i][2]));
        el.style.backgroundSize = t + 'px ' + t + 'px';
        return t;
      });
    }
    function drift(y) {
      if (!smoke.length || still.matches) return;
      var r = logo.getBoundingClientRect();
      if (r.bottom < 0 || r.top > window.innerHeight) return;
      for (var i = 0; i < smoke.length; i++) {
        var f = FLOW[i], t = tiles[i] || 1;
        smoke[i].style.transform = 'translate3d(' + wrap(y * f[0], t).toFixed(2) + 'px,' + wrap(y * f[1], t).toFixed(2) + 'px,0)' + f[3];
      }
    }
    function frame() {
      queued = false;
      drift(window.pageYOffset);
      var p = still.matches ? 0 : Math.min(1, Math.max(0, window.pageYOffset / span));
      p = Math.round(p * 1000) / 1000;
      if (p === last) return;
      last = p;
      hero.style.setProperty('--lp', String(p));
      hero.classList.toggle('is-scrolled', p > 0);
    }
    function queue() { if (!queued) { queued = true; window.requestAnimationFrame(frame); } }
    measure();
    frame();
    window.addEventListener('scroll', queue, { passive: true });
    window.addEventListener('resize', function () { measure(); queue(); });
    var img = logo.querySelector('.brand-logo__img');
    if (img && !img.complete) img.addEventListener('load', function () { measure(); queue(); }, { once: true });
    if (still.addEventListener) still.addEventListener('change', queue);
  }

  /* ---------- service picker: send to the right booking URL ---------- */
  var BOOK_LABEL = { smog: 'Book a Smog Check', registration: 'Book Registration Help', combo: 'Book Smog + Registration' };
  function initSelector() {
    document.querySelectorAll('[data-service-selector]').forEach(function (form) {
      // The button says what it books: Book a Smog Check, Book Registration Help, Book Smog + Registration.
      var go = form.querySelector('.selector__go');
      function name() {
        var chk = form.querySelector('input[name="service"]:checked');
        if (go && chk && BOOK_LABEL[chk.value]) go.textContent = BOOK_LABEL[chk.value];
      }
      form.querySelectorAll('input[name="service"]').forEach(function (i) { i.addEventListener('change', name); });
      name();
      form.addEventListener('submit', function (e) {
        var chk = form.querySelector('input[name="service"]:checked');
        if (!chk) return;
        var url = form.getAttribute('data-url-' + chk.value);
        if (url) { e.preventDefault(); window.location.href = url; }
      });
    });
  }

  /* ---------- booking request form ---------- */
  /* Days as YYYY-MM-DD, worked out in UTC so a day is never shifted by the visitor's time zone. */
  function ymdDate(ymd) { var p = ymd.split('-'); return new Date(Date.UTC(+p[0], +p[1] - 1, +p[2])); }
  function ymdAdd(ymd, n) { var d = ymdDate(ymd); d.setUTCDate(d.getUTCDate() + n); return d.toISOString().slice(0, 10); }
  function dayText(ymd, opts) { return new Intl.DateTimeFormat('en-US', Object.assign({ timeZone: 'UTC' }, opts)).format(ymdDate(ymd)); }
  var WHEN_PHRASE = { 'First Available': 'first available time', Morning: 'in the morning', Midday: 'around midday', Afternoon: 'in the afternoon', Evening: 'in the evening' };
  /* "Smog Check on Tuesday, October 6 at 10:30 AM" */
  function requestText(service, ymd, time) {
    if (!service || !/^\d{4}-\d{2}-\d{2}$/.test(ymd || '')) return '';
    var t = service + ' on ' + dayText(ymd, { weekday: 'long', month: 'long', day: 'numeric' });
    if (/^\d{1,2}:\d{2}/.test(time || '')) return t + ' at ' + time;
    return WHEN_PHRASE[time] ? t + ', ' + WHEN_PHRASE[time] : t;
  }

  function initBooking() {
    var form = document.getElementById('booking-request');
    var params = new URLSearchParams(location.search);
    if (document.querySelector('[data-booking-success]')) {
      var box = document.querySelector('[data-booking-success]');
      // Say what they asked for, from what was typed before sending.
      try {
        var sent = JSON.parse(sessionStorage.getItem('lqs_booking_draft') || '{}');
        var recap = box.querySelector('[data-booking-recap]');
        var said = requestText(sent['contact[Service]'], sent['contact[Preferred day]'], sent['contact[Preferred time]']);
        if (recap && said) { recap.textContent = said + '.'; recap.hidden = false; }
      } catch (e) {}
      box.focus();
      trackOnce('booking_request_saved', {}, 'booking_saved_' + location.search);
      try { sessionStorage.removeItem('lqs_booking_draft'); } catch (e) {}
      return;
    }
    if (!form) return;

    var svc = params.get('service');
    if (svc) {
      var r = form.querySelector('input[data-service-key="' + svc + '"]');
      if (r) r.checked = true;
    }
    var rt = params.get('type');
    if (rt && /^[a-z-]+$/.test(rt)) {
      var ro = form.querySelector('#bf-regtype option[data-type="' + rt + '"]');
      if (ro) ro.selected = true;
    }
    if (params.get('coupon')) {
      var cc = form.querySelector('[data-coupon-check]');
      if (cc) cc.checked = true;
    }

    var regType = form.querySelector('[data-reg-type]');
    var bring = document.querySelectorAll('[data-bring-for]');
    function syncService() {
      var key = (form.querySelector('input[data-service-key]:checked') || {}).getAttribute ? form.querySelector('input[data-service-key]:checked').getAttribute('data-service-key') : 'smog';
      var needsReg = key === 'registration' || key === 'combo';
      if (regType) {
        regType.hidden = !needsReg;
        var opt = regType.querySelector('.field__opt');
        if (opt) opt.hidden = true;
      }
      bring.forEach(function (g) {
        var f = g.getAttribute('data-bring-for');
        g.hidden = !(key === 'combo' || key === f);
      });
    }
    form.querySelectorAll('input[data-service-key]').forEach(function (i) { i.addEventListener('change', syncService); });
    syncService();

    var phone = form.querySelector('#bf-phone');
    var phoneOpt = form.querySelector('[data-phone-opt]');
    var consent = form.querySelector('[data-text-consent]');
    function syncConfirm() {
      var v = (form.querySelector('input[data-confirm]:checked') || {}).value || 'Email';
      var needPhone = v !== 'Email';
      if (phone) phone.required = needPhone;
      if (phoneOpt) phoneOpt.hidden = needPhone;
      if (consent) {
        consent.hidden = v !== 'Text Message';
        var box = consent.querySelector('input');
        if (box) box.required = v === 'Text Message';
      }
    }
    form.querySelectorAll('input[data-confirm]').forEach(function (i) { i.addEventListener('change', syncConfirm); });
    syncConfirm();

    var date = form.querySelector('[data-min-today]');
    if (date) date.min = laNow().ymd;

    var started = false;
    form.addEventListener('focusin', function () {
      if (started) return;
      started = true;
      var k = form.querySelector('input[data-service-key]:checked');
      track('booking_started', { journey: k ? k.getAttribute('data-service-key') : 'unknown' });
    });

    /* keep what the customer typed if Shopify returns a validation error */
    var DRAFT = 'lqs_booking_draft';
    form.addEventListener('submit', function () {
      try {
        var data = {};
        new FormData(form).forEach(function (v, k) { if (k.indexOf('contact[') === 0) data[k] = v; });
        sessionStorage.setItem(DRAFT, JSON.stringify(data));
      } catch (e) {}
    });
    var errors = document.querySelector('[data-form-errors]');
    if (errors) {
      try {
        var saved = JSON.parse(sessionStorage.getItem(DRAFT) || '{}');
        Object.keys(saved).forEach(function (k) {
          form.querySelectorAll('[name="' + k.replace(/"/g, '') + '"]').forEach(function (f) {
            if (f.type === 'radio' || f.type === 'checkbox') f.checked = f.value === saved[k];
            else f.value = saved[k];
          });
        });
        syncService(); syncConfirm();
      } catch (e) {}
      errors.focus();
    }
  }

  function initContact() {
    if (document.querySelector('[data-contact-success]')) {
      document.querySelector('[data-contact-success]').focus();
      trackOnce('contact_request_submitted', {}, 'contact_' + location.search);
    }
    var err = document.querySelector('#contact-form [data-form-errors]');
    if (err) err.focus();
  }

  /* ---------- coupon ---------- */
  function initCoupon() {
    var today = laNow().ymd;
    document.querySelectorAll('[data-coupon]').forEach(function (t) {
      var end = t.getAttribute('data-coupon-end');
      if (end && end < today) {
        /* page was cached after the end date: hide the offer everywhere */
        var sec = t.closest('.coupon-feature');
        if (sec) sec.hidden = true;
        t.hidden = true;
        // Only shown when the end date has passed: the page itself never carries an "ended" message.
        var exp = document.querySelector('[data-coupon-expired]');
        if (!exp && t.closest('.coupon-page__inner')) {
          exp = document.createElement('div');
          exp.className = 'coupon-empty';
          exp.setAttribute('data-coupon-expired', '');
          exp.innerHTML = '<p class="coupon-empty__lead">This coupon has ended.</p><p>Call or stop by to ask about current specials.</p>';
          t.closest('.coupon-page__inner').appendChild(exp);
          var fine = document.querySelector('.coupon-page__fine');
          if (fine) fine.hidden = true;
          var intro = document.querySelector('.coupon-page__intro');
          if (intro) intro.hidden = true;
        }
        if (exp) exp.hidden = false;
        document.querySelectorAll('[data-coupon-link]').forEach(function (a) { if (a.closest('.action-bar')) a.hidden = true; });
        return;
      }
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (ents) {
          if (ents.some(function (en) { return en.isIntersecting; })) { trackOnce('coupon_viewed', {}, 'coupon_viewed_' + location.pathname); io.disconnect(); }
        }, { threshold: 0.5 });
        io.observe(t);
      }
      var dlg = t.nextElementSibling && t.nextElementSibling.matches('[data-coupon-dialog]') ? t.nextElementSibling : null;
      var show = t.querySelector('[data-coupon-show]');
      if (show && dlg && typeof dlg.showModal === 'function') {
        show.addEventListener('click', function () { dlg.showModal(); track('coupon_shown', {}); });
        dlg.querySelectorAll('[data-dialog-close]').forEach(function (b) { b.addEventListener('click', function () { dlg.close(); }); });
        dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });
        dlg.addEventListener('close', function () { show.focus(); });
      } else if (show) show.hidden = true;
      var print = t.querySelector('[data-coupon-print]');
      if (print) print.addEventListener('click', function () {
        t.classList.add('print-target');
        document.body.classList.add('print-coupon');
        track('coupon_printed', {});
        window.print();
      });
    });
    window.addEventListener('afterprint', function () {
      document.body.classList.remove('print-coupon');
      document.querySelectorAll('.print-target').forEach(function (n) { n.classList.remove('print-target'); });
    });
  }

  /* ---------- click-to-load map (address + directions work without it) ---------- */
  function initMap() {
    document.querySelectorAll('[data-map-load]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var wrap = btn.closest('[data-map]');
        var f = document.createElement('iframe');
        f.className = 'map-frame';
        f.src = btn.getAttribute('data-map-src');
        f.title = 'Map showing Lathrop Quick Smog';
        f.loading = 'lazy';
        f.referrerPolicy = 'no-referrer-when-downgrade';
        wrap.innerHTML = '';
        wrap.appendChild(f);
        f.focus();
      });
    });
  }

  /* ---------- action bar: get out of the way while typing ---------- */
  function initActionBar() {
    var bar = document.querySelector('[data-action-bar]');
    if (!bar) return;
    document.addEventListener('focusin', function (e) {
      if (e.target.matches('input, select, textarea')) bar.classList.add('is-hidden');
    });
    document.addEventListener('focusout', function (e) {
      if (e.target.matches('input, select, textarea')) bar.classList.remove('is-hidden');
    });
  }

  /* ---------- staff app: live wait + booking requests ----------
     Theme settings > Staff app sets data-ops-url on <html>. The wait is read from
     the app's public, anonymous endpoint (counts and minutes only). A number is
     shown only while it's current: closed, paused, stale or unreachable = hidden. */
  var OPS = (document.documentElement.getAttribute('data-ops-url') || '').replace(/\/+$/, '');

  function initLiveWait() {
    if (!OPS || !document.documentElement.hasAttribute('data-ops-wait')) return;
    var chips = document.querySelectorAll('[data-live-chip]');
    var boards = document.querySelectorAll('[data-live-wait]');
    if (!chips.length && !boards.length) return;
    var shownLive = false;

    function ago(q) {
      var d = Math.round((Date.parse(q.checkedAt) - Date.parse(q.updatedAt)) / 60000);
      return isNaN(d) || d < 1 ? 'Updated just now' : 'Updated ' + d + ' min ago';
    }
    function hideAll() {
      chips.forEach(function (c) { c.hidden = true; });
      boards.forEach(function (b) { b.hidden = true; });
    }

    function render(q) {
      // The website's own hours win, so the page never says "open" and "closed" at once.
      if (q && q.state === 'live' && SHOP_OPEN === false) q = { state: 'closed', opensNote: SHOP_OPENS };
      if (q && q.state === 'closed' && SHOP_OPEN === true) q = null;
      if (!q || (q.state !== 'live' && q.state !== 'closed')) { hideAll(); return; }
      var live = q.state === 'live';
      var w = live ? q.waitMinutes : {};

      chips.forEach(function (c) {
        var key = w.smog !== null && w.smog !== undefined ? 'smog' : (w.registration !== null && w.registration !== undefined ? 'registration' : null);
        if (!live || !key) { c.hidden = true; return; }
        var label = key === 'smog' ? 'smog checks' : 'registration';
        var text = w[key] === 0 ? 'No wait for ' + label + ' right now' : (key === 'smog' ? 'Smog check' : 'Registration') + ' wait: about ' + w[key] + ' min';
        c.querySelector('[data-live-chip-text]').textContent = text;
        c.setAttribute('aria-label', text + '. See all live wait times.');
        c.hidden = false;
      });

      boards.forEach(function (b) {
        b.classList.toggle('is-closed', !live);
        b.querySelectorAll('[data-lw-open-only]').forEach(function (n) { n.hidden = !live; });
        var closed = b.querySelector('[data-lw-closed]');
        var note = b.querySelector('[data-lw-note]');
        b.querySelector('[data-lw-status-text]').textContent = live ? 'Live Queue' : 'Closed Now';
        if (!live) {
          closed.textContent = 'We’re closed right now.' + (q.opensNote ? ' ' + q.opensNote + '.' : '') + ' Book ahead and come in at your time.';
          closed.hidden = false;
          note.hidden = true;
          b.hidden = false;
          return;
        }
        closed.hidden = true;
        var any = false;
        b.querySelectorAll('[data-lw-service]').forEach(function (plate) {
          var m = w[plate.getAttribute('data-lw-service')];
          if (m === null || m === undefined) { plate.hidden = true; return; }
          any = true;
          plate.hidden = false;
          var v = plate.querySelector('[data-lw-value]');
          if (m === 0) v.textContent = 'Now';
          else { v.textContent = String(m); var u = document.createElement('small'); u.textContent = 'MIN'; v.appendChild(u); }
          plate.querySelector('[data-lw-label]').textContent = m === 0 ? 'No wait right now' : 'Estimated wait';
          plate.setAttribute('aria-label', plate.querySelector('.plate__top').textContent + ': ' + (m === 0 ? 'no wait right now' : 'about ' + m + ' minutes'));
        });
        if (!any) { b.hidden = true; return; }
        var text = q.source === 'staff' ? (q.note ? 'From our staff: ' + q.note : '') : '';
        note.textContent = text;
        note.hidden = !text;
        var parts = [ago(q)];
        if (q.waiting && q.waiting.total > 0) parts.push(q.waiting.total + (q.waiting.total === 1 ? ' car' : ' cars') + ' waiting');
        if (q.closesAt) parts.push('Open until ' + q.closesAt);
        b.querySelector('[data-lw-updated]').textContent = parts.join(' · ');
        b.hidden = false;
        if (!shownLive) { shownLive = true; trackOnce('live_wait_shown', {}, 'live_wait_' + location.pathname); }
      });
    }

    var busy = false;
    function load() {
      if (busy || document.hidden) return;
      busy = true;
      var ctrl = window.AbortController ? new AbortController() : null;
      var timer = setTimeout(function () { if (ctrl) ctrl.abort(); }, 8000);
      fetch(OPS + '/api/public/queue', { mode: 'cors', credentials: 'omit', signal: ctrl ? ctrl.signal : undefined })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(render, function () { render(null); })
        .then(function () { clearTimeout(timer); busy = false; });
    }
    // Once when the page opens; after that, every minute only while the shop is open (by the hours in
    // Theme settings), so the staff app's database can sleep overnight.
    function openNow() {
      var src = document.getElementById('lqs-hours');
      if (!src) return true;
      try {
        var hours = JSON.parse(src.textContent), now = laNow();
        return parseDay(hours[now.day]).some(function (s) { return now.mins >= s[0] && now.mins < s[1]; });
      } catch (e) { return true; }
    }
    load();
    setInterval(function () { if (openNow()) load(); }, 60000);
    document.addEventListener('visibilitychange', function () { if (!document.hidden && openNow()) load(); });
  }

  /* Copies each booking request / message to the staff app's lead list. The normal
     Shopify form submit still happens (and still emails the shop), so nothing is lost
     if the app can't be reached. One key per filled-in form, so a resubmit isn't a duplicate. */
  function leadKey(form) {
    var name = 'lqs_lead_key_' + form.id;
    var k = null;
    try { k = sessionStorage.getItem(name); } catch (e) {}
    if (!k) {
      var a = new Uint8Array(16);
      (window.crypto || window.msCrypto).getRandomValues(a);
      k = Array.prototype.map.call(a, function (x) { return ('0' + x.toString(16)).slice(-2); }).join('');
      try { sessionStorage.setItem(name, k); } catch (e) {}
    }
    return k;
  }
  function clearLeadKey(id) { try { sessionStorage.removeItem('lqs_lead_key_' + id); } catch (e) {} }

  /* A plain request that outlives the page (keepalive), not a beacon: ad blockers stop beacons
     ("hyperlink auditing"), and a stopped one used to lose the request without a trace. */
  function postLead(body, keepalive) {
    return fetch(OPS + '/api/public/leads', { method: 'POST', body: body, keepalive: !!keepalive, mode: 'cors', credentials: 'omit', headers: { 'Content-Type': 'text/plain;charset=UTF-8' } });
  }
  function sendLead(payload) {
    var body = JSON.stringify(payload);
    try {
      if (window.fetch) { postLead(body, true).catch(function () {}); return; }
    } catch (e) {}
    try { if (navigator.sendBeacon) navigator.sendBeacon(OPS + '/api/public/leads', new Blob([body], { type: 'text/plain;charset=UTF-8' })); } catch (e) {}
  }
  /* What was sent, kept until the thank-you page has sent it once more (the app keeps one copy per key),
     in case the first one didn't get through as the page went to Shopify. */
  var PENDING = 'lqs_lead_pending_';
  function keepPending(id, payload) { try { sessionStorage.setItem(PENDING + id, JSON.stringify(payload)); } catch (e) {} }
  function resendPending(id) {
    var body = null;
    try { body = sessionStorage.getItem(PENDING + id); } catch (e) {}
    if (!body || !window.fetch) return;
    var tries = 0;
    (function go() {
      tries++;
      postLead(body, false).then(function (r) {
        // Saved, or refused for good (it won't do better a second time): done either way.
        if (r.ok || (r.status >= 400 && r.status < 500 && r.status !== 429)) { try { sessionStorage.removeItem(PENDING + id); } catch (e) {} }
        else if (tries < 3) setTimeout(go, 4000);
      }).catch(function () { if (tries < 3) setTimeout(go, 4000); });
    })();
  }

  function initLeadForward() {
    if (!OPS || !document.documentElement.hasAttribute('data-ops-leads')) return;
    if (document.querySelector('[data-booking-success]')) { resendPending('booking-request'); clearLeadKey('booking-request'); }
    if (document.querySelector('[data-contact-success]')) { resendPending('contact-form'); clearLeadKey('contact-form'); }
    [['booking-request', 'booking'], ['contact-form', 'contact']].forEach(function (pair) {
      var form = document.getElementById(pair[0]);
      if (!form) return;
      form.addEventListener('submit', function () {
        try {
          var fd = new FormData(form);
          var g = function (k) { var v = fd.get('contact[' + k + ']'); return v ? String(v).trim() : ''; };
          var svc = form.querySelector('input[data-service-key]:checked');
          var p = {
            kind: pair[1], idempotencyKey: leadKey(form), company: String(fd.get('lqs_trap') || fd.get('lqs_company') || ''),
            name: g('name').slice(0, 80), email: g('email'), phone: g('phone'), message: g('body').slice(0, 1000),
          };
          if (pair[1] === 'booking') {
            p.service = svc ? svc.getAttribute('data-service-key') : undefined;
            p.registrationType = p.service && p.service !== 'smog' ? g('Registration type') : '';
            p.preferredDay = g('Preferred day');
            p.preferredTime = g('Preferred time');
            p.vehicleYear = g('Vehicle year');
            p.vehicleMake = g('Vehicle make');
            p.vehicleModel = g('Vehicle model');
            p.confirmBy = g('Confirm by') || undefined;
            p.textConsent = !!g('Text consent');
            p.coupon = g('Coupon');
          }
          keepPending(pair[0], p);
          sendLead(p);
        } catch (e) {}
      });
    });
  }

  /* Day and time, picked with a tap. Days come from the hours in Theme settings (the next 7 open days,
     plus Other day for the calendar). With the staff app connected, the open times for that day show as
     buttons, by part of the day; if the app can't be reached, the form keeps its parts of the day
     (Morning, Midday...) and the shop picks. Without JavaScript it's a date and a part of the day. */
  function initSlots() {
    var form = document.getElementById('booking-request');
    if (!form || document.querySelector('[data-booking-success]')) return;
    var day = form.querySelector('#bf-date');
    var sel = form.querySelector('#bf-window');
    if (!day || !sel) return;
    var NAME = 'contact[Preferred time]';
    function q(s) { return form.querySelector(s); }
    var dayField = q('[data-day-field]'), selField = q('[data-window-field]'), fields = q('[data-when-fields]');
    var dayBox = q('[data-day-picks]'), dayList = q('[data-day-list]');
    var timeBox = q('[data-time-picks]'), partsBox = q('[data-time-parts]'), timeList = q('[data-time-list]'), msg = q('[data-time-msg]');
    var help = q('[data-when-help]'), summary = q('[data-booking-summary]');
    var dayLabel = dayField ? dayField.querySelector('label') : null, dayLabelText = dayLabel ? dayLabel.textContent : '';
    var helpText = help ? help.textContent : '';
    var chips = false, seq = 0, part = null, days = [];
    // Shopify sent the form back with an error: keep the time they had picked.
    var pending = null;
    if (document.querySelector('[data-form-errors]')) {
      try { pending = JSON.parse(sessionStorage.getItem('lqs_booking_draft') || '{}')[NAME] || null; } catch (e) {}
    }

    function layout() { if (fields) fields.hidden = (!dayField || dayField.hidden) && (!selField || selField.hidden); }
    function picked() { var r = form.querySelector('input[name="' + NAME + '"]:checked'); return r ? r.value : ''; }
    function service() { var k = q('input[data-service-key]:checked'); return k ? k.getAttribute('data-service-key') : 'smog'; }
    function say(text, alert) {
      if (!msg) return;
      msg.textContent = text || '';
      msg.hidden = !text;
      msg.classList.toggle('is-error', !!alert);
      if (alert) msg.setAttribute('role', 'alert'); else msg.removeAttribute('role');
    }
    function summarize() {
      if (!summary) return;
      var k = q('input[data-service-key]:checked');
      var t = k ? requestText(k.value, day.value, chips ? picked() : sel.value) : '';
      summary.textContent = '';
      if (t && (!chips || picked())) {
        summary.appendChild(document.createTextNode('Your request: '));
        var b = document.createElement('strong');
        b.textContent = t;
        summary.appendChild(b);
      }
      summary.hidden = !summary.textContent;
    }
    function chip(name, value, lines, cls, extra) {
      var l = document.createElement('label');
      l.className = 'pick__chip ' + cls;
      var i = document.createElement('input');
      i.type = 'radio'; i.name = name; i.value = value; i.className = 'visually-hidden';
      if (name !== NAME) i.setAttribute('form', 'lqs-day-picker'); // not sent: the date field carries the day
      l.appendChild(i);
      lines.forEach(function (t, n) { var s = document.createElement('span'); s.className = n ? 'pick__sub' : 'pick__main'; s.textContent = t; l.appendChild(s); });
      if (extra) { var h = document.createElement('span'); h.className = 'visually-hidden'; h.textContent = extra; l.appendChild(h); }
      return l;
    }

    /* ---- days ---- */
    var hours = null;
    try { var src = document.getElementById('lqs-hours'); hours = src ? JSON.parse(src.textContent) : null; } catch (e) {}
    var KEYS = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];
    if (hours && dayBox && dayList && dayField) {
      var now = laNow();
      for (var i = 0; i < 28 && days.length < 7; i++) {
        var ymd = ymdAdd(now.ymd, i);
        var spans = parseDay(hours[KEYS[ymdDate(ymd).getUTCDay()]]);
        if (!spans.length) continue;
        if (i === 0 && now.mins + 45 > spans[spans.length - 1][1]) continue; // too late to book today
        days.push(ymd);
      }
    }
    function setDay(v) {
      var other = v === 'other';
      dayField.hidden = !other;
      if (dayLabel) dayLabel.textContent = other ? 'Pick a date' : dayLabelText;
      if (!other) day.value = v;
      else if (days.indexOf(day.value) !== -1) day.value = '';
      layout();
    }
    if (days.length) {
      days.forEach(function (ymd) {
        dayList.appendChild(chip('lqs_day', ymd, [ymd === now.ymd ? 'Today' : dayText(ymd, { weekday: 'short' }), dayText(ymd, { month: 'short', day: 'numeric' })], 'pick__chip--day'));
      });
      dayList.appendChild(chip('lqs_day', 'other', ['Other day'], 'pick__chip--day pick__chip--other'));
      var start = !day.value ? days[0] : (days.indexOf(day.value) !== -1 ? day.value : 'other');
      dayList.querySelector('input[value="' + start + '"]').checked = true;
      setDay(start);
      dayBox.hidden = false;
      dayList.addEventListener('change', function (e) { if (e.target.name === 'lqs_day') { setDay(e.target.value); load(); } });
    }

    /* ---- times ---- */
    var PARTS = [['morning', 'Morning'], ['afternoon', 'Afternoon'], ['evening', 'Evening']];
    function partOf(v) { var m = toMins(v); return m < 720 ? 'morning' : (m < 960 ? 'afternoon' : 'evening'); }
    function useChips(on) {
      chips = on;
      sel.disabled = on;
      if (selField) selField.hidden = on;
      if (timeBox) timeBox.hidden = !on;
      if (help) help.textContent = on ? 'These are the open times right now. We’ll confirm your appointment by your chosen method.' : helpText;
      layout();
    }
    function restore() { useChips(false); if (pending && Array.prototype.some.call(sel.options, function (o) { return o.value === pending; })) sel.value = pending; pending = null; summarize(); }
    function showPart(p) {
      part = p;
      timeList.querySelectorAll('[data-part]').forEach(function (g) { g.hidden = g.getAttribute('data-part') !== p; });
      partsBox.querySelectorAll('[data-part]').forEach(function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-part') === p)); });
    }
    function render(b, keep) {
      timeList.innerHTML = '';
      partsBox.innerHTML = '';
      partsBox.hidden = true;
      if (!b.open) { say('We’re closed that day. Pick another day.'); return; }
      if (!b.times.length) { say('That day is fully booked. Pick another day.'); return; }
      say('');
      var groups = {}, keepPart = null;
      b.times.forEach(function (t) { var p = partOf(t.value); (groups[p] = groups[p] || []).push(t); });
      var have = PARTS.filter(function (p) { return groups[p[0]]; });
      have.forEach(function (p) {
        var g = document.createElement('div');
        g.className = 'pick__grid pick__grid--times';
        g.setAttribute('data-part', p[0]);
        groups[p[0]].forEach(function (t) {
          var m = String(t.label).match(/^(\d{1,2}:\d{2})\s*(AM|PM)$/i);
          var c = chip(NAME, t.label, [m ? m[1] : t.label], 'pick__chip--time', m ? ' ' + m[2].toUpperCase() : '');
          if (keep && t.label === keep) { c.querySelector('input').checked = true; keepPart = p[0]; }
          g.appendChild(c);
        });
        timeList.appendChild(g);
        var btn = document.createElement('button');
        btn.type = 'button'; btn.className = 'pick__part'; btn.textContent = p[1];
        btn.setAttribute('data-part', p[0]);
        partsBox.appendChild(btn);
      });
      partsBox.hidden = false;
      showPart(keepPart || (part && groups[part] ? part : have[0][0]));
    }
    function load() {
      summarize();
      if (!OPS || !timeBox || !timeList || !partsBox) return;
      var d = day.value;
      var mine = ++seq;
      var keep = pending || picked();
      if (!/^\d{4}-\d{2}-\d{2}$/.test(d)) {
        if (chips) { timeList.innerHTML = ''; partsBox.hidden = true; say('Pick a day to see the open times.'); }
        return;
      }
      if (chips) { timeList.innerHTML = ''; partsBox.hidden = true; say('Finding open times…'); }
      fetch(OPS + '/api/public/slots?day=' + d + '&service=' + encodeURIComponent(service()), { mode: 'cors', credentials: 'omit' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (b) {
          if (mine !== seq) return;
          if (!b || !Array.isArray(b.times)) { restore(); return; }
          pending = null;
          useChips(true);
          render(b, keep);
          summarize();
        }, function () { if (mine === seq) restore(); });
    }

    if (OPS && timeBox && timeList && partsBox) {
      // Times as buttons from the start (no flash of the part-of-day list); back to it if the app can't answer.
      useChips(true);
      say('Finding open times…');
      partsBox.addEventListener('click', function (e) { var b = e.target.closest('[data-part]'); if (b) showPart(b.getAttribute('data-part')); });
      timeList.addEventListener('change', function () { say(''); summarize(); });
      form.addEventListener('submit', function (e) {
        if (!chips || picked()) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        var none = !timeList.querySelector('input');
        say(none ? 'Pick another day: that one has no open times.' : 'Pick a time.', true);
        var target = none ? (dayList && dayList.querySelector('input:checked')) : timeList.querySelector('[data-part]:not([hidden]) input');
        if (target) target.focus({ preventScroll: true });
        timeBox.scrollIntoView({ block: 'center', behavior: 'smooth' });
      });
    }
    day.addEventListener('change', load);
    sel.addEventListener('change', summarize);
    form.querySelectorAll('input[data-service-key]').forEach(function (i) { i.addEventListener('change', load); });
    load();
  }

  /* ---------- Google reviews ----------
     The "From our customers" section asks the staff app for the shop's 5-star Google reviews when
     it's about to scroll into view (Google doesn't allow keeping copies, so each view looks them up).
     Shown as written, with Google Maps credited and each reviewer's name, photo and profile link.
     If they can't be had, the section keeps the reviews added in the theme editor, or stays hidden. */
  function initReviews() {
    var sec = document.querySelector('[data-google-reviews]');
    if (!OPS || !sec) return;
    var list = sec.querySelector('[data-reviews-list]');
    var summary = sec.querySelector('[data-reviews-summary]');
    var note = sec.querySelector('[data-reviews-note]');
    var want = Math.max(1, Math.min(5, parseInt(sec.getAttribute('data-count'), 10) || 3));
    var started = false;

    function el(tag, cls, text) {
      var e = document.createElement(tag);
      if (cls) e.className = cls;
      if (text != null) e.textContent = text;
      return e;
    }
    function link(href, text, cls) {
      var a = el('a', cls || '', text);
      a.href = href; a.target = '_blank'; a.rel = 'noopener';
      return a;
    }
    function stars(n, label) {
      var p = el('p', 'review__stars');
      p.setAttribute('role', 'img');
      p.setAttribute('aria-label', label || (n + ' out of 5 stars'));
      for (var i = 0; i < 5; i++) { var s = el('span', i < n ? 'is-on' : '', '\u2605'); s.setAttribute('aria-hidden', 'true'); p.appendChild(s); }
      return p;
    }
    function card(r) {
      var li = el('li', 'review review--google');
      li.appendChild(stars(5));
      var q = el('blockquote'), body = el('p', 'review__text', r.text);
      q.appendChild(body);
      li.appendChild(q);
      var more = el('button', 'review__more', 'More');
      more.type = 'button'; more.hidden = true;
      more.addEventListener('click', function () {
        var open = li.classList.toggle('is-open');
        more.textContent = open ? 'Less' : 'More';
        more.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
      li.appendChild(more);
      var by = el('div', 'review__by review__by--google');
      if (r.photo) {
        var img = el('img', 'review__avatar');
        img.src = r.photo; img.alt = ''; img.width = 36; img.height = 36; img.loading = 'lazy'; img.decoding = 'async';
        img.referrerPolicy = 'no-referrer';
        img.addEventListener('error', function () { img.remove(); });
        by.appendChild(img);
      }
      var who = el('span', 'review__who');
      who.appendChild(r.authorUrl ? link(r.authorUrl, r.author, 'review__name') : el('span', 'review__name', r.author));
      var when = el('span', 'review__when');
      if (r.when) when.appendChild(document.createTextNode(r.when + ' on '));
      when.appendChild(r.url ? link(r.url, 'Google Maps') : document.createTextNode('Google Maps'));
      who.appendChild(when);
      by.appendChild(who);
      li.appendChild(by);
      if (r.flagUrl) {
        var f = link(r.flagUrl, 'Report', 'review__flag');
        f.setAttribute('aria-label', 'Report this review to Google');
        li.appendChild(f);
      }
      return li;
    }
    function show(data) {
      var rs = (data.reviews || []).slice(0, want);
      if (!rs.length) return;
      list.textContent = '';
      rs.forEach(function (r) { list.appendChild(card(r)); });
      list.setAttribute('data-n', String(rs.length));
      var p = data.place || {};
      if (summary && p.rating) {
        summary.textContent = '';
        summary.appendChild(stars(Math.round(p.rating), p.rating + ' out of 5 stars on Google'));
        var txt = el('span', 'reviews__rating', p.rating.toFixed(1));
        summary.appendChild(txt);
        var rest = p.count ? (' from ' + p.count.toLocaleString('en-US') + ' reviews on ') : ' on ';
        summary.appendChild(document.createTextNode(rest));
        summary.appendChild(p.url ? link(p.url, 'Google Maps', 'text-link text-link--light') : document.createTextNode('Google Maps'));
        summary.hidden = false;
      }
      if (note) {
        note.textContent = '5-star reviews with comments from Google Maps, in Google\u2019s most-relevant order.';
        note.hidden = false;
      }
      sec.hidden = false;
      // "More" only on reviews too long for their card (measured once it's on the page, and again on resize).
      function fit() {
        list.querySelectorAll('.review--google').forEach(function (li) {
          var t = li.querySelector('.review__text'), b = li.querySelector('.review__more');
          if (!t || !b || li.classList.contains('is-open')) return;
          b.hidden = !(t.scrollHeight > t.clientHeight + 2);
        });
      }
      requestAnimationFrame(fit);
      var rt;
      window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(fit, 150); });
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(fit);
      track('reviews_shown', { count: rs.length });
    }
    function load() {
      if (started) return;
      started = true;
      fetch(OPS + '/api/public/reviews', { mode: 'cors', credentials: 'omit' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (d) { if (d && d.ok) show(d); })
        .catch(function () {});
    }
    // A hidden section has no size, so watch what comes before it instead.
    var watch = sec.hidden ? (sec.closest('.shopify-section') || sec).previousElementSibling || sec : sec;
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (ents) {
        if (ents.some(function (e) { return e.isIntersecting; })) { io.disconnect(); load(); }
      }, { rootMargin: '600px 0px' });
      io.observe(watch);
    } else load();
  }

  function ready(fn) { if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }
  ready(function () {
    [initMenu, initOpenStatus, initTrace, initLogoScroll, initSelector, initBooking, initSlots, initContact, initCoupon, initMap, initActionBar, initLiveWait, initLeadForward, initReviews].forEach(function (f) {
      try { f(); } catch (e) { if (window.console) console.warn('[lqs]', f.name, e); }
    });
  });
})();
